import { google as Google, Loader, LoaderOptions } from 'google-maps';
import { Config } from '@/config';

const loaderOptions: LoaderOptions = { libraries: ['places'] };
const loader = new Loader(Config.GoogleMapApiKey, loaderOptions);

/* eslint-disable @typescript-eslint/no-var-requires, global-require */
export const MAP_ICONS = {
  mapIconPink: require('@/assets/images/map_pin_pink.png'),
  mapIconBlack: require('@/assets/images/map_pin_black.png'),
};

/**
 * Initializes Google Maps if it's not initialized yet. And return {Google} instance.
 * @return {Promise<Google>}
 */
export async function initializeGoogleMaps(): Promise<Google> {
  if (window.google?.maps) {
    return window.google as Google;
  }
  return loader.load();
}

/**
 * Return embed google map iframe src
 * @see https://developers.google.com/maps/documentation/embed/get-started
 * @param latitude {number}
 * @param longitude {number}
 * @return {string}
 */
export function embedMapSrc(latitude: number, longitude: number): string {
  const coords = `${latitude},${longitude}`;
  // 0.002 - to make the map center a little bit lower
  const center = `${latitude + 0.002},${longitude}`;

  return `https://www.google.com/maps/embed/v1/place?key=${Config.GoogleMapApiKey}&q=${coords}&zoom=14&center=${center}`;
}
